class RestoreRouteAssignmentsComponent {
    /*@ngInject*/
    constructor(Auth, $state, User, DateUtil, $translate, $q, Modal, RestoreRouteAssignmentService, DataCounter, UserBranchService, CommonLayoutService, Navigation, $rootScope) {
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.$q = $q;
        this.Modal = Modal;
        this.RestoreRouteAssignmentService = RestoreRouteAssignmentService;
        this.DataCounter = DataCounter;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            loggedInUserId: User.getUser().id,
            loading: false,
            searchText: null,
            locRouteAssignmentObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                toggleSelect: false,
                selectedLocRouteChangeIds: []
            },
            localLang: this.CommonLayoutService.multiSelectLangTranslation()
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/restore-route-assignments');
    }

    $onInit() {
        // this.model.loading = true;
        // this.SetupService.get(this.model.currentBranch)
        //     .then((data) => {
        //         this.model.branchCurrentVaultDate = this.DateUtil.convertToDate(data.currentVaultDate);
        //         this.model.date = this.model.branchCurrentVaultDate;
        //         this.model.maxVaultDate = { maxDate: this.model.branchCurrentVaultDate };
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     })
        //     .finally(() => {
        //         this.model.loading = false;
        //     })
        this.loadUserBranches();
    }

    findLocationRouteChange() {
        setTimeout(() => {
            this.model.locRouteAssignmentObj.loading = true;
            const branch = this.model.selectedBranch && this.model.selectedBranch.length ? this.model.selectedBranch.map(d => d.branchId).toString() : this.model.branch;

            this.RestoreRouteAssignmentService.getLocationRouteChange(this.model.locRouteAssignmentObj.searchText, branch,
                (this.model.locRouteAssignmentObj.pagination.page - 1) * this.model.locRouteAssignmentObj.pagination.pageLimit,
                this.model.locRouteAssignmentObj.pagination.pageLimit)
                .then((data) => {
                    this.model.locRouteAssignmentObj.pagination.total = data.totalRecords;
                    this.model.locRouteAssignmentObj.results = data.results;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message)
                    }
                })
                .finally(() => {
                    this.model.locRouteAssignmentObj.loading = false;
                })
        });
    }

    goToLocation(locationId) {
        this.Navigation.goToLocationTab(locationId);
    }

    pageChange() {
        this.model.locRouteAssignmentObj.toggleSelect = !this.model.locRouteAssignmentObj.toggleSelect;
        this.findLocationRouteChange();
    }

    searchRecords() {
        this.model.locRouteAssignmentObj.pagination.page = 1;
        this.findLocationRouteChange();
    }

    selectAllLocations() {
        this.model.locRouteAssignmentObj.toggleSelect = !this.model.locRouteAssignmentObj.toggleSelect;
        this.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];

        this.model.locRouteAssignmentObj.results.forEach(d => {
            if (this.model.locRouteAssignmentObj.toggleSelect) {
                d.isSelected = this.model.locRouteAssignmentObj.toggleSelect;
                this.model.locRouteAssignmentObj.selectedLocRouteChangeIds.push({ id: d.locRouteChangeId, locationId: d.locationId })
            }
            else {
                d.isSelected = this.model.locRouteAssignmentObj.toggleSelect;
                this.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];
            }
        });
    }

    selectLocations(data, index) {
        if (data.isSelected) {
            this.model.locRouteAssignmentObj.selectedLocRouteChangeIds.push({ id: data.locRouteChangeId, locationId: data.locationId });
        }
        else {
            this.model.locRouteAssignmentObj.selectedLocRouteChangeIds.splice(index, 1);
        }
    }

    undoLocationRouteChange() {
        this.model.loading = true;
        this.RestoreRouteAssignmentService.undoLocationRouteChange(this.model.locRouteAssignmentObj.selectedLocRouteChangeIds,
            this.model.currentBranch, this.model.loggedInUserId)
            .then(() => {
                this.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];
                this.findLocationRouteChange();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadUserBranches() {
        this.UserBranchService.getUserBranches(this.model.loggedInUserId)
            .then((data) => {
                this.model.userBranchList = data.results;
                this.model.totalBranches = this.model.userBranchList.length;

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.currentBranch) {
                        branch.ticked = true;
                    }
                })

                this.findLocationRouteChange();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    resetPagination() {
        this.model.locRouteAssignmentObj.pagination.page = 1;
    }

}

export default RestoreRouteAssignmentsComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/restore_route_assignments/restore_route_assignments.controller.js